import {
  ASSET_STATUS_LIST, ASSET_STATUS_LIST_SUCCESS, ASSET_STATUS_LIST_FAILURE,
  ASSET_STATUS_DATA, ASSET_STATUS_DATA_SUCCESS, ASSET_STATUS_DATA_FAILURE,
  ASSET_STATUS_CREATE, ASSET_STATUS_CREATE_SUCCESS, ASSET_STATUS_CREATE_FAILURE,
  ASSET_STATUS_UPDATE, ASSET_STATUS_UPDATE_SUCCESS, ASSET_STATUS_UPDATE_FAILURE,
  ASSET_STATUS_DELETE, ASSET_STATUS_DELETE_SUCCESS, ASSET_STATUS_DELETE_FAILURE,
} from "./actionType";

export const assetStatusList = () => ({ type: ASSET_STATUS_LIST });
export const assetStatusListSuccess = (data) => ({ type: ASSET_STATUS_LIST_SUCCESS, payload: data });
export const assetStatusListFailure = (error) => ({ type: ASSET_STATUS_LIST_FAILURE, payload: error });

export const assetStatusData = (data) => ({ type: ASSET_STATUS_DATA, payload: data });
export const assetStatusDataSuccess = (data) => ({ type: ASSET_STATUS_DATA_SUCCESS, payload: data });
export const assetStatusDataFailure = (error) => ({ type: ASSET_STATUS_DATA_FAILURE, payload: error });

export const assetStatusCreate = (data) => ({ type: ASSET_STATUS_CREATE, payload: data });
export const assetStatusCreateSuccess = (data) => ({ type: ASSET_STATUS_CREATE_SUCCESS, payload: data });
export const assetStatusCreateFailure = (error) => ({ type: ASSET_STATUS_CREATE_FAILURE, payload: error });

export const assetStatusUpdate = (data) => ({ type: ASSET_STATUS_UPDATE, payload: data });
export const assetStatusUpdateSuccess = (data) => ({ type: ASSET_STATUS_UPDATE_SUCCESS, payload: data });
export const assetStatusUpdateFailure = (error) => ({ type: ASSET_STATUS_UPDATE_FAILURE, payload: error });

export const assetStatusDelete = (data) => ({ type: ASSET_STATUS_DELETE, payload: data });
export const assetStatusDeleteSuccess = (data) => ({ type: ASSET_STATUS_DELETE_SUCCESS, payload: data });
export const assetStatusDeleteFailure = (error) => ({ type: ASSET_STATUS_DELETE_FAILURE, payload: error });